// # #############################################
// # Title : Mouse Enter Leave
// # Authors : Sameer, Mahesh
// # Date : 15th October 2019
// # Last Modified : Sameer, July 2019
// # Version : 19.10.03
// # Description : This is an Aframe function
// # ############################################

// Aframe Function (DO NOT CHANGE)

const AFRAME = window.AFRAME;

AFRAME.registerComponent("hover", {
  init: function () {
    this.el.addEventListener("mouseenter", function (evt) { });
  }
});
